<sui-dialog-header (closeButtonClick)="_closeDialog()">
  {{ _data.initial ? '프로필을 설정해 주세요.' : '프로필 편집하기' }}
</sui-dialog-header>
<div
  class="profile-saving-overlay"
  *ngIf="_showProfileSavingLoader"
  aria-busy="true"
>
  <div class="profile-saving-loading-content">
    <sui-loader></sui-loader>
  </div>
</div>
<section>
  <main>
    <div class="profile">
      <div class="avatar-area">
        <sui-reading-group-member-avatar [avatarImageURL]="_uploadImage">
        </sui-reading-group-member-avatar>
        <button
          class="delete-img-button"
          *ngIf="!_isImageUploading && _uploadImage"
          [disabled]="_isProfileSaving"
          (click)="_onClickDeleteImage()"
        >
          <sui-icon name="엑스"></sui-icon>
        </button>

        <div class="avatar-loader" *ngIf="_showImageUploadingLoader">
          <sui-loader></sui-loader>
        </div>
      </div>
      <button
        class="profile-select"
        [disabled]="_isImageUploading || _isProfileSaving"
        (click)="_onClickUploadImage()"
      >
        사진 선택
      </button>
      <input
        type="file"
        accept="image/png,image/jpeg,image/jpg"
        #fileInput
        style="display: none"
        (change)="_onFileChanged($event)"
      />
    </div>

    <div class="input-form-container">
      <div *ngIf="_data.initial" class="initial-desc">
        북이오에서 사용할 닉네임과 프로필 이미지를 설정해 주세요.<br />지금
        변경을 원하지 않으시는 경우 언제든 '내 서재' 메뉴에서 변경 가능합니다.
      </div>

      <div class="input-form">
        <div class="header">
          <span class="nickname">닉네임 변경</span>
          <p>비속어 / 욕설 사용 시, 서비스 이용에 제한이 될 수 있습니다.</p>
        </div>
        <div class="inner">
          <span class="header-mobile">닉네임 변경</span>
          <div class="inner-container">
            <input
              type="text"
              [(ngModel)]="_nickname"
              (ngModelChange)="_changeNickname()"
              (keyup.enter)="_onClickDuplicate()"
              placeholder="변경할 닉네임을 입력해주세요."
              [disabled]="_isDuplicateChecking || _isProfileSaving"
            />
            <button
              class="duplicate-check-button"
              [disabled]="
                _isDuplicateChecking ||
                _isProfileSaving ||
                _trimmedNicknameLength < 2 ||
                _trimmedNicknameLength > 20 ||
                _isSameNicknameAsCurrent ||
                (_lastDuplicateCheckedNickname === null &&
                  !_nicknameEverDeviatedFromOpen) ||
                ((_isDuplication === 'not-duplicate' ||
                  _isDuplication === 'duplicate') &&
                  _nickname === _lastDuplicateCheckedNickname)
              "
              (click)="_onClickDuplicate()"
            >
              <ng-container
                *ngIf="!_showDuplicateCheckingLoader; else duplicateLoading"
              >
                중복 확인
              </ng-container>
              <ng-template #duplicateLoading>
                <sui-loader></sui-loader>
              </ng-template>
            </button>
            <div class="alert-message-container">
              <span
                class="text-limit"
                *ngIf="
                  (_isTextLength < 2 || _isTextLength > 20) && !_isPageInit
                "
                >2-20자 이내</span
              >
              <span
                class="already-use"
                *ngIf="
                  _isSameNicknameAsCurrent &&
                  _trimmedNicknameLength >= 2 &&
                  _trimmedNicknameLength <= 20 &&
                  !_isPageInit
                "
                >동일한 닉네임으로는 변경할 수 없습니다.</span
              >
              <span class="already-use" *ngIf="_isDuplication === 'duplicate'"
                >이미 사용중인 닉네임입니다.</span
              >
              <span class="not-use" *ngIf="_isDuplication === 'not-duplicate'"
                >사용가능한 닉네임 입니다.</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <div class="submit-container">
    <button
      *ngIf="_isImageChanged"
      sui-solid-button
      varSize="large"
      [disabled]="
        _isSubmitLocked ||
        _isImageUploading ||
        _isDuplicateChecking ||
        _isProfileSaving ||
        _isDuplication === 'duplicate' ||
        _isDuplication === 'test-necessary'
      "
      (click)="_onClickSubmit()"
    >
      저장하기
    </button>
    <button
      *ngIf="!_isImageChanged"
      sui-solid-button
      varSize="large"
      [disabled]="
        _isSubmitLocked ||
        _isImageUploading ||
        _isDuplicateChecking ||
        _isProfileSaving ||
        _isDuplication !== 'not-duplicate'
      "
      (click)="_onClickSubmit()"
    >
      저장하기
    </button>
  </div>
</section>
